import { YandexMetrica } from './index'

const SUBSCRIPTION_PENDING_KEY = 'ym_subscription_pending'
const SUBSCRIPTION_SUCCESS_SENT_KEY = 'ym_subscription_success_sent'

const PACK_GOAL_BY_ID: Record<number, string> = {
    1: 'pack1_success',
    2: 'pack2_success',
    3: 'pack3_success',
}

export const markSubscriptionPaymentStarted = () => {
    if (typeof window === 'undefined') return
    localStorage.setItem(SUBSCRIPTION_PENDING_KEY, '1')
    localStorage.removeItem(SUBSCRIPTION_SUCCESS_SENT_KEY)
}

export const trackSubscriptionSuccessIfPending = () => {
    if (typeof window === 'undefined') return
    const hasPendingPayment = localStorage.getItem(SUBSCRIPTION_PENDING_KEY) === '1'
    const alreadySent = localStorage.getItem(SUBSCRIPTION_SUCCESS_SENT_KEY) === '1'
    if (!hasPendingPayment || alreadySent) return

    YandexMetrica.reachGoal('sub_success')
    localStorage.setItem(SUBSCRIPTION_SUCCESS_SENT_KEY, '1')
    localStorage.removeItem(SUBSCRIPTION_PENDING_KEY)
}

export const trackPackSuccessByPackageId = (packageId: number) => {
    const goalId = PACK_GOAL_BY_ID[packageId]
    if (!goalId) return
    YandexMetrica.reachGoal(goalId)
}
